// extracted by mini-css-extract-plugin
export var banner = "_qu-0";
export var settingRow = "_qu-2";
export var titleIcon = "_qu-1";